/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/global-search-box/app.global-search-box.component.ts.
 */
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {GlobalSearchResult} from '../../models/global-search-result';
import {AppSearchService} from '../../services/app.search.service';
import {AppPageloaderService} from '../../services/app.pageloader.service';
import {GlobalSearchResultEntry} from '../../models/global-search-result-entry';
import {Router} from '@angular/router';
import {AppMemoryService} from '../../services/app.memory.service';
import {AppEventService} from '../../services/app.event.service';
import {AppMobileService} from '../../services/app.mobile.service';

/**
 * Zweck: Beschreibt class AppGlobalSearchBoxComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'global-search-box',
    templateUrl: 'app.global-search-box.component.html',
    styleUrls: ['app.global-search-box.component.scss'],
    standalone: false
})
export class AppGlobalSearchBoxComponent implements OnInit, OnDestroy {

  widthPx;
  widthPercent;


  widthPxMin = 150;

  focus = false;
  searchValue: string;

  has_search = false;

  searchReady = false;

  focusOutTimeout: any;

  showResults = new BehaviorSubject<boolean>(false);

  results = new BehaviorSubject<GlobalSearchResult[]>(null);

  @ViewChild('globalSearchInput') globalSearchInput: ElementRef;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppSearchService, private loader: AppPageloaderService, public msvc: AppMobileService,
              private router: Router, private mem: AppMemoryService, private esvc: AppEventService) {
  }

/**
 * Beschreibt Methode clickResultEntry und ihren Rückgabevertrag.
 */
  clickResultEntry(result: GlobalSearchResultEntry) {
    if (result.payload && result.payload.memSet) {
      Object.keys(result.payload.memSet).forEach(k => {
        this.mem.set(k, result.payload.memSet[k]);
      });
      this.esvc.addGuiEvent('globalSearchResultClicked');
    }
    if (result.url) {
      if (result.url.startsWith('/')) {
        this.router.navigate([result.url], {queryParams: result.params});
      } else {
        window.location.href = result.url;
      }
    }
  }

/**
 * Beschreibt Methode keyUP und ihren Rückgabevertrag.
 */
  keyUP() {
    if (this.searchValue) {
      this.has_search = true;

      this.searchReady = this.searchValue.length >= 3;

    } else {
      this.has_search = false;
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.focusOut();
  }

/**
 * Beschreibt Methode reset und ihren Rückgabevertrag.
 */
  reset($event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    this.searchValue = '';
    this.results.next(null);
    this.showResults.next(false);
    this.keyUP();



    if (this.globalSearchInput) {
      this.globalSearchInput.nativeElement.focus();
    }
  }

/**
 * Beschreibt Methode focusIn und ihren Rückgabevertrag.
 */
  focusIn() {
    if (this.focusOutTimeout) {
      clearTimeout(this.focusOutTimeout);
    }
    this.focus = true;
    this.widthPercent = 100;
    if (this.results.value) {
      this.showResults.next(true);
    }
  }

/**
 * Beschreibt Methode focusOut und ihren Rückgabevertrag.
 */
  focusOut() {
    this.focusOutTimeout = setTimeout(() => {
      this.focus = false;
      this.widthPercent = null;
      this.widthPx = this.widthPxMin;
      this.showResults.next(false);
    }, 400);
  }

/**
 * Beschreibt Methode search und ihren Rückgabevertrag.
 */
  search() {
    if (this.searchReady) {
      this.searchReady = false;
      this.showResults.next(true);
      const l = this.loader.start();

      this.svc.globalSearch(this.searchValue).subscribe(res => {
        this.results.next(res);
        l.stop();
      });
    }
  }
}
